import {
  PopoverPosition as BlueprintPopoverPosition,
  TextArea as BlueprintTextArea,
  TextAreaProps as BlueprintTextAreaProps,
} from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import {
  SystemInfo,
  SystemInfoProps,
} from 'bones/design-system/components/notifications/SystemInfo';
import {
  SystemMessage,
  SystemMessageProps,
} from 'bones/design-system/components/notifications/SystemMessage';
import { Body } from 'bones/design-system/components/typography/Body';

export type TextareaProps = Omit<
  BlueprintTextAreaProps,
  'fill' | 'inputRef' | 'intent' | 'large' | 'small'
> & {
  'data-testid'?: never;
  actions?: React.ReactNode;
  helpProps?: Omit<SystemMessageProps, 'variant'>;
  infoProps?: Omit<SystemInfoProps, 'position'>;
  invalid?: boolean;
  label: string;
  labelInside?: boolean;
  testId?: string;
  textAreaRef?: React.RefObject<BlueprintTextArea>;
};

export const Textarea: React.VFC<TextareaProps> = ({
  actions,
  className,
  disabled,
  helpProps,
  id,
  infoProps,
  invalid,
  label,
  labelInside,
  required,
  testId,
  textAreaRef,
  value = '',
  ...props
}) => (
  <div
    className={classNames(className, 'vb-textarea', {
      'vb-textarea-state--disabled': disabled,
      'vb-textarea-state--invalid': invalid,
      'vb-textarea-state--label-inside': labelInside,
    })}
  >
    {label ? (
      <label className="vb-textarea-label" htmlFor={id}>
        <Body size="md">{label}</Body>
        {required ? (
          <Body className="vb-textarea-label-required" size="md">
            *
          </Body>
        ) : null}
        {infoProps ? (
          <SystemInfo
            position={BlueprintPopoverPosition.TOP}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...infoProps}
          />
        ) : null}
      </label>
    ) : null}
    <div className="vb-textarea-input-container">
      <BlueprintTextArea
        ref={textAreaRef}
        className="vb-textarea-input"
        data-testid={testId}
        disabled={disabled}
        id={id}
        value={value}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
      <div className="vb-textarea-input-actions">{actions}</div>
    </div>
    {helpProps ? (
      <SystemMessage
        variant={invalid ? 'alert' : 'text'}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...helpProps}
      />
    ) : null}
  </div>
);
